import { Outlet } from 'react-router-dom';
import { SidebarProvider, useSidebar } from '@features/ui';
import { cn } from '@lib/utils';
import { RightSidebar } from '@features/core/ui/layout/rightSidebar.tsx';

import { AdminSidebar } from './adminSidebar';
import { AdminHeader } from './adminHeader';

const AdminContent = () => {
  const { isRight } = useSidebar();

  return (
    <>
      {isRight ? <RightSidebar /> : <AdminSidebar />}
      <div
        className={cn(
          'ml-auto w-full max-w-full',
          'peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]',
          'peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]',
          'transition-[width] duration-200 ease-linear',
          'flex h-svh flex-col',
          'group-data-[scroll-locked=1]/body:h-full',
          'group-data-[scroll-locked=1]/body:has-[main.fixed-main]:h-svh',
          'p-3 md:p-0'
        )}
        id="content"
      >
        <AdminHeader />
        <div className={'p-5'}>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export const AdminLayout = () => {
  return (
    <div>
      <SidebarProvider>
        <AdminContent />
      </SidebarProvider>
    </div>
  );
};
